var _excluded = ["options", "label", "placeholder", "multiple", "clearable", "fullWidth", "required", "disabled", "error", "helperText", "onChange", "value", "maxMenuHeight"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import ReactSelect from 'react-select';
import { MaterialUIThemeProvider } from "../../helpers/material-ui-theme";
import { isEmpty } from "../../helpers/data";
import { Control, DropdownIndicator, ClearIndicator, NoOptionsMessage, Placeholder, SingleValue, Menu, ValueContainer, Option, MultiValue, Input } from "./components";
import { useStyles, selectStyles } from "./Select.styles";
var components = {
  Option: Option,
  Menu: Menu,
  Control: Control,
  MultiValue: MultiValue,
  NoOptionsMessage: NoOptionsMessage,
  Placeholder: Placeholder,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer,
  DropdownIndicator: DropdownIndicator,
  ClearIndicator: ClearIndicator,
  Input: Input
};
export var Select = function Select(_ref) {
  var options = _ref.options,
      label = _ref.label,
      placeholder = _ref.placeholder,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      _ref$clearable = _ref.clearable,
      clearable = _ref$clearable === void 0 ? true : _ref$clearable,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      helperText = _ref.helperText,
      onChange = _ref.onChange,
      value = _ref.value,
      _ref$maxMenuHeight = _ref.maxMenuHeight,
      maxMenuHeight = _ref$maxMenuHeight === void 0 ? 320 : _ref$maxMenuHeight,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles({
    fullWidth: fullWidth
  });

  var getOptionValue = function getOptionValue(option) {
    return option.value;
  };

  var getValue = React.useCallback(function (options, value) {
    if (!multiple && (typeof value === 'string' || typeof value === 'number') && !isEmpty(value)) {
      // if string, find option
      return options === null || options === void 0 ? void 0 : options.find(function (option) {
        return getOptionValue(option) === value;
      });
    }

    if (multiple && Array.isArray(value) && value !== null && value !== void 0 && value.some(function (selectedValue) {
      return typeof selectedValue === 'string' || typeof selectedValue === 'number';
    })) {
      // if array of strings, get option of each value
      return value.map(function (currentValue) {
        return options === null || options === void 0 ? void 0 : options.find(function (option) {
          return getOptionValue(option) === currentValue;
        });
      });
    }

    return value;
  }, [multiple]);
  var cleanValue = getValue(options, value);
  return /*#__PURE__*/React.createElement(MaterialUIThemeProvider, null, /*#__PURE__*/React.createElement(ReactSelect, _extends({}, restProps, {
    portalPlacement: "auto",
    menuPlacement: "auto",
    isMulti: multiple,
    isClearable: clearable,
    classes: classes,
    styles: selectStyles,
    isDisabled: disabled,
    TextFieldProps: {
      label: label,
      fullWidth: fullWidth,
      helperText: helperText,
      required: required,
      disabled: disabled,
      error: error,
      placeholder: placeholder || label,
      InputLabelProps: {
        shrink: true
      }
    },
    options: options || [],
    components: components,
    value: cleanValue,
    menuPortalTarget: document.querySelector('body'),
    onChange: onChange,
    maxMenuHeight: maxMenuHeight
  })));
};
Select.displayName = 'Select';